import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useTaskContext } from '../store/AlltasksContext';

interface EditableNameProps {
  initialName?: string;
  placeholder?: string;
  onNameChange?: (name: string) => void;
  markerImage: string;
}

const AddNameBtn: React.FC<EditableNameProps> = ({
  initialName = 'Image/Gif/Video\nQuestion 1',
  placeholder = 'your name',
  onNameChange,
  markerImage,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(initialName);

  const { activeStep, Tabname } = useTaskContext();

  // 🔑 Sync state with prop change
  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleButtonClick = () => setIsEditing(true);
  const handleBlur = () => setIsEditing(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newName = event.target.value;
    setName(newName);
    if (onNameChange) onNameChange(newName);
  };

  // Translation logic
  const translateLineToHindi = (line: string) => {
    if (line === 'Image/Gif/Video') return 'छवि/जीआईएफ/वीडियो';
    if (line.startsWith('Question')) {
      const parts = line.split(' ');
      return `प्रश्न ${parts[1] || ''}`;
    }
    return line;
  };

  const translateLineToEnglish = (line: string) => {
    if (line === 'छवि/गिफ/वीडियो' || line === 'छवि/जीआईएफ/वीडियो') return 'Image/Gif/Video';
    if (line.startsWith('प्रश्न')) {
      const parts = line.split(' ');
      return `Question ${parts[1] || ''}`;
    }
    return line;
  };

  const normalizeTabname = (tab: string) => {
    if (tab === 'शैक्षिक कार्य') return 'Educational Task';
    if (tab === 'उपलब्धता कार्य') return 'Availability Task';
    if (tab === 'सर्वेक्षण') return 'Survey Task';
    if (tab === 'प्रतिक्रिया') return 'Feedback Task';
    if (tab === 'डॉटकोड स्कैनिंग कार्य') return 'Dotcode Scanning Task';
    return tab;
  };

  const nameLines = name.split('\n');
  const normalizedTab = normalizeTabname(Tabname);

  let displayLines = nameLines;

  if (
    ['Availability Task', 'Educational Task', 'Survey Task', 'Feedback Task', 'Image Capture Task', 'Dotcode Scanning Task'].includes(normalizedTab)
  ) {
    displayLines = activeStep === 2 ? nameLines.map(translateLineToHindi) : nameLines.map(translateLineToEnglish);
  }

  const displayName = displayLines.join('\n');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {isEditing ? (
        <TextField
          value={name}
          onChange={handleInputChange}
          onBlur={handleBlur}
          autoFocus
          variant="standard"
          placeholder={placeholder}
          multiline
          sx={{
            fontSize: "20px",
            fontWeight: "600",
          color: "#282829",
            "&. MuiInputBase-root:before": { border: "0 !important" },
            "&. MuiInputBase-root:after": { border: "0 !important" }
          }}
        />
      ) : (
        <Typography sx={{ whiteSpace: "pre-line", fontSize: "20px", fontWeight: "600", color: "#282829" }} variant="h5">
          {displayName}
        </Typography>
      )}
      <Button sx={{ padding: "0 !important", minWidth: "unset !important" }} onClick={handleButtonClick}>
        <img src={markerImage} alt="marker" />
      </Button>
    </Box>
  );
};

export default AddNameBtn;